import {SettingsContainer} from './components/settings-container';

export default {
    component: SettingsContainer
};
